export const KeyCodes={Fo:32,oo:9,To:13,_h:27};